import { useTranslate } from "@tolgee/react";
import { useState } from "react";
import type { Post } from "#/lib/api/posts";
import { matchesSearchQuery } from "#/lib/hangul-search";
import { stripMarkdown } from "#/lib/markdown-plain";

export type UseLearnSearchResult = {
	query: string;
	setQuery: (value: string) => void;
	isSearching: boolean;
	matches: readonly Post[];
	hasResults: boolean;
};

/** fetch된 learn 코퍼스(활성 locale로 이미 리졸브됨) 위에서 클라이언트 검색.
 *  한글 초성 매칭 포함 (matchesSearchQuery). */
export function useLearnSearch(posts: readonly Post[]): UseLearnSearchResult {
	const { t } = useTranslate();
	const [query, setQuery] = useState("");

	const isSearching = query.trim().length > 0;
	const matches = isSearching
		? posts.filter((post) =>
				matchesSearchQuery(query, [
					post.title,
					stripMarkdown(post.body),
					t(`learn.section.${post.category}`),
				]),
			)
		: [];

	return {
		query,
		setQuery,
		isSearching,
		matches,
		hasResults: matches.length > 0,
	};
}
